export interface Modal {
  open(e?): void;
  close?(e?): void;
}

export default abstract class AbstractModal implements Modal {
  private readonly closeModalSelector: string = '.js-closeModal';
  private readonly modalWidth: string = '500px';

  protected constructor(protected templateSelector: string, protected openSelector?: string, private bindToBody = false) {
    this.bindOpen();
  }

  protected bindOpen(): void {
    if (!this.openSelector) return;

    if (this.bindToBody) {
      $(document.body).on('click', this.openSelector, (e): void => {
        this.open(e);
      });
    } else {
      $(this.openSelector).on('click', (e): void => {
        this.open(e);
      });
    }
  }

  protected bindClose(): void {
    $(this.closeModalSelector).on('click', () => this.close());
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  protected openCallback = (e?: JQuery.ClickEvent): void => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  protected closeCallback = (): void => {};

  // eslint-disable-next-line class-methods-use-this
  close(): void {
    $.colorbox.close();
  }

  open(e?: JQuery.ClickEvent): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    window.ACC.colorbox.open('', {
      html: $(this.templateSelector).html(),
      width: this.modalWidth,
      onComplete: (): void => {
        this.bindClose();
        this.openCallback(e);
        $.colorbox.resize();
      },
      onClosed: (): void => {
        this.closeCallback();
      },
    });
  }
}
